import {SET_CUSTOMER, SET_HIGHLIGHTED} from "./actionTypes";

const initialState = {
    currentCustomer: localStorage.getItem("currentCustomer")?.replace(/"/g, "") || "",
    highlightedList: JSON.parse(localStorage.getItem("highlightedList")) || []
};

export const customerReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_CUSTOMER:
            return {
                ...state,
                currentCustomer: action.payload,
            };
        case SET_HIGHLIGHTED:
            return {
                ...state,
                highlightedList: action.payload,
            };
        default:
            return state;
    }
};

